import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight } = FiIcons;

export default function ServiceCard({ service, detailed = false }) {
  return (
    <article className={`service-card ${detailed ? 'service-card-detailed' : ''}`}>
      {detailed && <img src={service.image} alt="" className="service-card-image" />}
      <div className="service-card-content">
        <span className="service-number">{service.number}</span>
        <h3>{service.title}</h3>
        <p>{service.description}</p>
        {detailed && (
          <button className="text-link" type="button">
            Enquire About This Service <SafeIcon icon={FiArrowUpRight} />
          </button>
        )}
      </div>
    </article>
  );
}